import store from "@/store";
import { getWordFormBasedOnTheCount } from "@/views/Report/utils";

const ALL_EMPLOYEES_COUNT = "all";

export const getReportDetailsEmployeeCountText = (...counts) => {
  const resolvedCounts = counts
      .map((count) => {
        if (count === ALL_EMPLOYEES_COUNT) {
          const currentCompany = store.state.company.userCompany;

          return currentCompany ? currentCompany.employee_count : null;
        }

        return count;
      })
      .filter((count) => count !== null && count !== undefined && count !== "");

  if (!resolvedCounts.length) {
    return null;
  }

  if (counts.length > 1 && resolvedCounts.length > 1) {
    return `${resolvedCounts.join(" / ")} сотрудников`;
  }

  const count = resolvedCounts[0];

  return `${count} ${getWordFormBasedOnTheCount(
      count,
      "сотрудник",
      "сотрудника",
      "сотрудников"
  )}`;
};
